import Api from "../component/api/default";

let Auth = (function () {
    let AuthClass = function () { }; // 声明AuthClass对象，无法在外部直接调用
    AuthClass.prototype.freeCode = null;
    AuthClass.prototype.check = function (code, cb) {
        if (this.freeCode) {
            cb(this.freeCode[code]);
        }
        Api.getFreeCode(cdata => {
            this.freeCode = cdata;
            cb(!!this.freeCode[code]);
        });
    }

    let instance; // 声明一个instance对象
    return function () {
        if (instance) { // 如果已存在 则返回instance
            return instance;
        }
        instance = new AuthClass() // 如果不存在 则new一个
        return instance;
    }
})();

export default new Auth();